import { render, staticRenderFns } from "./TicketsMantenimiento.vue?vue&type=template&id=c6c8de94&scoped=true&"
import script from "./TicketsMantenimiento.vue?vue&type=script&lang=js&"
export * from "./TicketsMantenimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c8de94",
  null
  
)

export default component.exports